import { __assign, __spreadArray } from '../../_virtual/_tslib.js';
import { MapTo } from '@adobe/aem-react-editable-components';
import { ComponentMapping } from '@adobe/aem-spa-component-mapping';
import { Constants } from '@adobe/aem-spa-page-model-manager';
import { Mapper } from './enum.js';

var ITEMS_PROP = Constants.ITEMS_PROP, TYPE_PROP = Constants.TYPE_PROP;
var ComponentsManager = /** @class */ (function () {
    function ComponentsManager(options) {
        var _this = this;
        this._appId = '';
        this._componentsToBeMapped = [];
        this._componentMapping = ComponentMapping.instance;
        this._mappedResourceTypes = [];
        if (options === null || options === void 0 ? void 0 : options.appId)
            this._appId = options.appId;
        if (options === null || options === void 0 ? void 0 : options.propsViewer)
            this._propsViewer = options.propsViewer;
        if (options === null || options === void 0 ? void 0 : options.componentsToBeMapped) {
            this._componentsToBeMapped = options.componentsToBeMapped.map(function (componentToBeMapped) {
                if (_this.appId) {
                    componentToBeMapped.resourceType =
                        componentToBeMapped.resourceType.replace('{APP_ID}', _this.appId);
                }
                return componentToBeMapped;
            });
        }
    }
    Object.defineProperty(ComponentsManager.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentsManager.prototype, "componentsToBeMapped", {
        get: function () {
            return this._componentsToBeMapped;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentsManager.prototype, "componentMapping", {
        get: function () {
            return this._componentMapping;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentsManager.prototype, "propsViewer", {
        get: function () {
            return this._propsViewer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentsManager.prototype, "mappedResourceTypes", {
        get: function () {
            return this._mappedResourceTypes;
        },
        enumerable: false,
        configurable: true
    });
    ComponentsManager.prototype.extractComponentsResourceTypes = function (model, componentsResourceTypes) {
        var _this = this;
        if (componentsResourceTypes === void 0) { componentsResourceTypes = []; }
        var type = model === null || model === void 0 ? void 0 : model[TYPE_PROP];
        if (type)
            componentsResourceTypes.push(type);
        var items = model === null || model === void 0 ? void 0 : model[ITEMS_PROP];
        if (items) {
            var walkableItems = Object.values(items);
            walkableItems.forEach(function (walkableItem) {
                _this.extractComponentsResourceTypes(walkableItem, componentsResourceTypes);
            });
        }
        return componentsResourceTypes.filter(function (value, index, array) { return array.indexOf(value) === index; });
    };
    ComponentsManager.prototype.getMissingComponentsMapping = function (componentsToBeMapped, pageModel) {
        var _this = this;
        var _a;
        if (this.propsViewer) {
            var resourceTypes_1 = componentsToBeMapped.map(function (_a) {
                var resourceType = _a.resourceType;
                return resourceType;
            });
            var componentsResourceTypes = pageModel === null || pageModel === void 0 ? void 0 : pageModel.componentsResourceTypes;
            if (!componentsResourceTypes) {
                componentsResourceTypes =
                    this.extractComponentsResourceTypes(pageModel);
            }
            var missingResourceTypes = (_a = componentsResourceTypes === null || componentsResourceTypes === void 0 ? void 0 : componentsResourceTypes.filter(function (x) { return !resourceTypes_1.includes(x); }).filter(function (item) { return item !== 'nt:unstructured'; }).filter(function (item) { return item !== 'nt:folder'; })) !== null && _a !== void 0 ? _a : [];
            if (missingResourceTypes.length > 0) {
                console.warn("ResourceTypes map missing for: ".concat(missingResourceTypes.join(', '), ". PropsViewer component will be used as temporary replace"));
                var missingComponentsToBeMapped = missingResourceTypes.map(function (resourceType) {
                    var PropsViewer = __assign(__assign({}, _this.propsViewer), { resourceType: resourceType });
                    return PropsViewer;
                });
                return missingComponentsToBeMapped;
            }
        }
        return [];
    };
    ComponentsManager.prototype.map = function (pageModel) {
        var _this = this;
        var componentsToBeMapped = __spreadArray(__spreadArray([], this.componentsToBeMapped, true), this.getMissingComponentsMapping(this.componentsToBeMapped, pageModel), true);
        componentsToBeMapped.forEach(function (_a) {
            var resourceType = _a.resourceType, component = _a.component, mapper = _a.mapper;
            if (!_this.mappedResourceTypes.includes(resourceType)) {
                if (mapper === Mapper.MAP_TO) {
                    MapTo(resourceType)(component);
                }
                else if (mapper === Mapper.COMPONENT_MAPPING) {
                    _this.componentMapping.map(resourceType, component);
                }
                _this._mappedResourceTypes.push(resourceType);
            }
        });
    };
    return ComponentsManager;
}());

export { ComponentsManager };
//# sourceMappingURL=index.js.map
